import Icon1 from './1.webp';
import Icon2 from './2.webp';
import Icon3 from './3.webp';
import Icon4 from './4.webp';
import Icon5 from './5.webp';
import Icon6 from './6.webp';
export { Icon1, Icon2, Icon3, Icon4, Icon5,Icon6}